import { useState } from 'react'

import { TimeRange } from 'types'

import { getInitialRangeState } from './utils'

export const useTimeRange = (initialTimeRange?: TimeRange) => {
  const [timeRange, setTimeRange] = useState(
    initialTimeRange ? getInitialRangeState(initialTimeRange) : undefined,
  )

  return {
    timeRange,
    setTimeRange,
  }
}
